import { REQUEST_HEADER_AUTH_KEY, TOKEN_TYPE, URL_XUSER } from 'constants/api.constant'
import ApiService, { getToken } from './ApiService'
import { APP_XUSER_CODE } from 'constants/app.constant'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: `${URL_XUSER}/v1/login`,
        method: 'post',
        data: { ...data, app: APP_XUSER_CODE }
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data
    })
}

export async function apiGetUsers() {
    const accessToken = getToken()
    return ApiService.fetchData({
        url: `${URL_XUSER}/User?top=1000`,
        method: 'get',
        headers: { [REQUEST_HEADER_AUTH_KEY]: `${TOKEN_TYPE}${accessToken}` }
    })
}
export async function apiGetUsersNew(params) {
    const queryParams = new URLSearchParams(params).toString()

    return ApiService.fetchData({
        url: `${URL_XUSER}/v1/users?${queryParams}`,
        method: 'get'
    })
}
export async function apiGetUserById(id) {
   
    
    return ApiService.fetchData({
        url: `${URL_XUSER}/v1/users/${id}`,
        method: 'get',
        // headers: { [REQUEST_HEADER_AUTH_KEY]: `${TOKEN_TYPE}${accessToken}` }
    })
}

export async function apiGetProfilePicture() {
    return ApiService.fetchData({
        url: `${URL_XUSER}/v1/profile/picture`,
        method: 'get',
        
    })
}



